import AxiosInstance from "./api";

export const RequestForPaymentService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/request-for-payment", { params: query });
  },
  getById: async (id) => {
    return await AxiosInstance.get(`/private/request-for-payment/${id}`);
  },
  create: async (payload) => {
    return await AxiosInstance.post("/private/request-for-payment", payload);
  },
  update: async (id, payload) => {
    return await AxiosInstance.patch(`/private/request-for-payment/${id}`, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete(`/private/request-for-payment/${id}`);
  },
};
